import script from "./PrivatServiceModuleComp.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivatServiceModuleComp.vue?vue&type=script&setup=true&lang=js"

import "./PrivatServiceModuleComp.vue?vue&type=style&index=0&id=0188019a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0188019a"]])

export default __exports__